import { render, staticRenderFns } from "./CreateNewUserModal.vue?vue&type=template&id=bd4b3ce2&scoped=true&"
import script from "./CreateNewUserModal.vue?vue&type=script&lang=js&"
export * from "./CreateNewUserModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewUserModal.vue?vue&type=style&index=0&id=bd4b3ce2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4b3ce2",
  null
  
)

export default component.exports